//angular references
import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { RequestOptions } from '@angular/http';
import { Router } from '@angular/router';

//BusinessEvent control references
import { BEDataService } from '../../services/businessEvent/beData.service';
import { BEWorkflowSteps } from '../../services/businessEvent/beWorkflow.model';

//Config references
import { ConfigDataService, enumClientConfig, enumUIConfig } from '../../services/configuration/configData.service';

//Era model references
import { BusinessEvent } from '../../models/businessevent.model';
import { OTA_Response } from '../../models/ota_response.model';
import { OTA_VehAvail } from '../../models/ota_vehavail.model';
import { OTA_PricedCoverage } from '../../models/ota_pricedcoverage.model';
import { CurrencyAmount } from '../../models/currencyamount.model';
import { OTA_Request, enumRequestType } from '../../models/ota_request.model';
import { OTA_VehPref } from '../../models/ota_vehpref.model';
import { OTA_VehType } from '../../models/ota_vehtype.model';
import { OTA_Error } from '../../models/ota_error.model';
import { enumCallStatus } from '../../models/callStatus.model';
import { KeyValuePair } from '../../models/keyvaluepair.model';
import { OTA_VehModifyRQ } from '../../models/ota_vehmodifyrq.model';
import { OTA_VehCancelRQ } from '../../models/ota_vehcancelrq.model';
import { OTA_VehResRQ } from '../../models/ota_vehresrq.model';
import { OTA_VehRetResRQ } from '../../models/ota_vehretresrq.model';
import { OTA_OffLocService } from '../../models/ota_offlocservice.model';
import { enumPromotionType } from '../../models/promotiontype.model';

enum enumAsyncLoad {
    OTAResponse = 1,
    UIConfigs = 2,
    ClientConfigs = 3,
};

@Component({
    selector: 'beVehicleSelection',
    template: require('./beVehicleSelection.component.html'),
    styles: [require('../app/app.component.css')]
})

export class BEVehicleSelectionComponent {
    //page/workflow 
    private _title = 'Choose your vehicle';
    private _currentStep = BEWorkflowSteps.beVehicleSelection;
    private _nextStep = "";
    private _previousStep = "";
    private _canPayNow = false;
    private _imageHeight = 100;
    private _smallImageWidth = 300;
    private _baseVehImgURL = "/img/vehicleImages/";
    private _baseIconImgURL: string = "/img/icons/";
    private _showAuxVehicleInfo = false;

    private _font: string = "";
    private _textColour: string = "";
    private _invalidTextColour: string = "";
    private _invalidBorderColour: string = "";
    private _containerBackColour: string = "";
    private _containerBorderColour: string = "";
    private _containerCornerRadius: string = "";
    private _inactiveTabColour: string = "";
    private _containerBorderFull: string = "";

    //private _locationOutTextColour: string = "";
    //private _locationOutBorderColour: string = "";

    private _commandButtonFont: string = "";
    private _commandButtonRadius: string = "";
    private _commandButtonTextSize: string = "";
    private _commandButtonTextWeight: string = "";
    private _primaryCommandButtonTextColour: string = "";
    private _primaryCommandButtonBackColour: string = "";
    private _primaryCommandButtonBorderFull: string = "";
    private _secondaryCommandButtonTextColour: string = "";
    private _secondaryCommandButtonBackColour: string = "";
    private _secondaryCommandButtonBorderFull: string = "";

    private _vehicleImageBorderStyle: string = "";

    private _vehPayNowButtonTextColour: string = "";
    private _vehPayNowButtonBackColour: string = "";
    private _vehPayNowButtonBorderFull: string = "";
    private _vehPayLaterButtonTextColour: string = "";
    private _vehPayLaterButtonBackColour: string = "";
    private _vehPayLaterButtonBorderFull: string = "";
    private _vehRequestButtonTextColour: string = "";
    private _vehRequestButtonBackColour: string = "";
    private _vehRequestButtonBorderFull: string = "";
    private _vehUnavailableButtonTextColour: string = "";
    private _vehUnavailableButtonBackColour: string = "";
    private _vehUnavailableButtonBorderFull: string = "";

    private _excessToCaption: string = "excess to";
    private _passengerCaption: string = "passenger";
    private _suitcaseCaption: string = "suitcase";
    private _airconCaption: string = "Air con";
    private _unavailableCaption: string = "Unavailable";

    //loaded 
    private _fullyLoaded: boolean = false;
    private _loadingErrorMsgs: string[] = new Array();
    private _loaded = [
        {
            step: enumAsyncLoad.OTAResponse,
            loaded: false,
        },
        {
            step: enumAsyncLoad.UIConfigs,
            loaded: false,
        },
        {
            step: enumAsyncLoad.ClientConfigs,
            loaded: false,
        },
    ];

    //business event parameters
    private _be: BusinessEvent;
    private _otaResponse: OTA_Response;
    private _locationOut: string = "";
    private _locationIn: string = "";
    private _dateTimeOut: string;
    private _dateTimeIn: string;
    private _otaVehAvails: OTA_VehAvail[];
    private _deliveryAddress: string = "";
    private _collectionAddress: string = "";
    private _reference: string = "";
    private _payNow: boolean = false;

    //error/change tracking
    private _hasVehicle = false;
    private _hasError = false;
    private _hasChanged = false;

    //
    //component events
    //
    public constructor(private _router: Router,
        private _beDataService: BEDataService,
        private _configDataService: ConfigDataService,
        private _httpClient: HttpClient,
        @Inject('BASE_URL') private _baseUrl: string)
    {
        this._nextStep = this._beDataService.nextStep(this._currentStep);
        this._previousStep = this._beDataService.previousStep(this._currentStep);
    }

    private async ngOnInit() {
        //get the current BusinessEvent's VehicleSelection data
        this._be = this._beDataService.getBusinessEventForStep(this._currentStep);

        //construct the OTA Request object for the current business event
        let otaReq: OTA_Request = this.createOTARequest();

        //get the OTA Available Vehicles for the current BusinessEvent
        this._httpClient.get<OTA_Response>(this._baseUrl + 'api/OTAData/OTARequest?'
            + '&otaReqJSON=' + JSON.stringify(otaReq)).subscribe(result => {
                this._otaResponse = result;
                this.asyncLoaded(enumAsyncLoad.OTAResponse);
            }, error => console.error(error));

        //get the configured UIConfigs
        if (this._configDataService.uiConfigs == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/UIConfigs').subscribe(result => {
                this._configDataService.uiConfigs = result;
                this.asyncLoaded(enumAsyncLoad.UIConfigs);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.UIConfigs);

        //get the configured ClientConfigs
        if (this._configDataService.clientConfigs == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/ClientConfigs').subscribe(result => {
                this._configDataService.clientConfigs = result;
                this.asyncLoaded(enumAsyncLoad.ClientConfigs);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.ClientConfigs);
    }

    //
    //component management
    //
    private asyncLoaded(step: enumAsyncLoad) {
        let fullyLoaded: boolean = true;

        for (var i = 0; i < this._loaded.length; i++) {
            if (this._loaded[i].step === step) {
                //record the given step as being loaded
                this._loaded[i].loaded = true;
            }
            else if (!this._loaded[i].loaded) {
                //check if all async steps have been loaded
                fullyLoaded = false;
            }
        }

        switch (step) {

            case enumAsyncLoad.OTAResponse:
                break;

            case enumAsyncLoad.UIConfigs:
                let font: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_Font);
                let textColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_TextColour);
                let invalidTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InvalidTextColour);
                let invalidBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InvalidControlBorderColour);
                let containerBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBackgroundColour);
                let containerBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBorderColour);
                let containerCornerRadius: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerCornerRadius);
                let inactiveTabColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InactiveTabColour);
                let containerBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBorderStyle);

                let commandButtonFont: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonFont);
                let commandButtonRadius: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonRadius);
                let commandButtonTextSize: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonTextSize);
                let commandButtonTextWeight: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonTextWeight);

                let primaryCommandButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonTextColour);
                let primaryCommandButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBackgroundColour);
                let primaryCommandButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBorderColour);
                let primaryCommandButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBorderStyle);

                let secondaryCommandButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonTextColour);
                let secondaryCommandButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBackgroundColour);
                let secondaryCommandButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBorderColour);
                let secondaryCommandButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBorderStyle);

                let vehicleImageBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehicleImageBorderStyle);

                let vehPayNowButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehPayNowButtonTextColour);
                let vehPayNowButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehPayNowButtonBackColour);
                let vehPayNowButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehPayNowButtonBorderColour);
                let vehPayNowButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehPayNowButtonBorderStyle);

                let vehPayLaterButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehPayLaterButtonTextColour);
                let vehPayLaterButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehPayLaterButtonBackColour);
                let vehPayLaterButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehPayLaterButtonBorderColour);
                let vehPayLaterButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehPayLaterButtonBorderStyle);

                let vehRequestButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehRequestButtonTextColour);
                let vehRequestButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehRequestButtonBackColour);
                let vehRequestButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehRequestButtonBorderColour);
                let vehRequestButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehRequestButtonBorderStyle);

                let vehUnavailableButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehUnavailableButtonTextColour);
                let vehUnavailableButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehUnavailableButtonBackColour);
                let vehUnavailableButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehUnavailableButtonBorderColour);
                let vehUnavailableButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_VehUnavailableButtonBorderStyle);

                let excessToCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ExcessToCaption);
                let passengerCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PassengerCaption);
                let suitcaseCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SuitcaseCaption);
                let airconCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_AirConCaption);
                let unavailableCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_UnavailableCaption);

                if (font.trim().length > 0) {
                    this._font = font;
                }
                if (textColour.trim().length > 0) {
                    this._textColour = textColour;
                }
                if (invalidTextColour.trim().length > 0) {
                    this._invalidTextColour = invalidTextColour;
                }
                if (invalidBorderColour.trim().length > 0) {
                    this._invalidBorderColour = invalidBorderColour;
                }
                if (containerBackColour.trim().length > 0) {
                    this._containerBackColour = containerBackColour;
                }
                if (containerBorderColour.trim().length > 0) {
                    this._containerBorderColour = containerBorderColour;
                }
                if (containerCornerRadius.trim().length > 0) {
                    this._containerCornerRadius = containerCornerRadius;
                }
                if (inactiveTabColour.trim().length > 0) {
                    this._inactiveTabColour = inactiveTabColour;
                }
                if ((containerBorderStyle.trim().length > 0)
                    || (containerBorderColour.trim().length > 0)) {
                    this._containerBorderFull = containerBorderColour + " " + containerBorderStyle;
                }

                if (commandButtonFont.trim().length > 0) {
                    this._commandButtonFont = commandButtonFont;
                }
                if (commandButtonRadius.trim().length > 0) {
                    this._commandButtonRadius = commandButtonRadius;
                }
                if (commandButtonTextSize.trim().length > 0) {
                    this._commandButtonTextSize = commandButtonTextSize;
                }
                if (commandButtonTextWeight.trim().length > 0) {
                    this._commandButtonTextWeight = commandButtonTextWeight;
                }
                if (primaryCommandButtonTextColour.trim().length > 0) {
                    this._primaryCommandButtonTextColour = primaryCommandButtonTextColour;
                }
                if (primaryCommandButtonBackColour.trim().length > 0) {
                    this._primaryCommandButtonBackColour = primaryCommandButtonBackColour;
                }
                if ((primaryCommandButtonBorderStyle.trim().length > 0)
                    || (primaryCommandButtonBorderColour.trim().length > 0)) {
                    this._primaryCommandButtonBorderFull = primaryCommandButtonBorderColour + " " + primaryCommandButtonBorderStyle;
                }
                if (secondaryCommandButtonTextColour.trim().length > 0) {
                    this._secondaryCommandButtonTextColour = secondaryCommandButtonTextColour;
                }
                if (secondaryCommandButtonBackColour.trim().length > 0) {
                    this._secondaryCommandButtonBackColour = secondaryCommandButtonBackColour;
                }
                if ((secondaryCommandButtonBorderStyle.trim().length > 0)
                    || (secondaryCommandButtonBorderColour.trim().length > 0)) {
                    this._secondaryCommandButtonBorderFull = secondaryCommandButtonBorderColour + " " + secondaryCommandButtonBorderStyle;
                }

                if (vehicleImageBorderStyle.trim().length > 0) {
                    this._vehicleImageBorderStyle = vehicleImageBorderStyle;
                }

                if (vehPayNowButtonTextColour.trim().length > 0) {
                    this._vehPayNowButtonTextColour = vehPayNowButtonTextColour;
                }
                if (vehPayNowButtonBackColour.trim().length > 0) {
                    this._vehPayNowButtonBackColour = vehPayNowButtonBackColour;
                }
                if ((vehPayNowButtonBorderColour.trim().length > 0)
                    || (vehPayNowButtonBorderStyle.trim().length > 0)) {
                    this._vehPayNowButtonBorderFull = vehPayNowButtonBorderColour + " " + vehPayNowButtonBorderStyle;
                }

                if (vehPayLaterButtonTextColour.trim().length > 0) {
                    this._vehPayLaterButtonTextColour = vehPayLaterButtonTextColour;
                }
                if (vehPayLaterButtonBackColour.trim().length > 0) {
                    this._vehPayLaterButtonBackColour = vehPayLaterButtonBackColour;
                }
                if ((vehPayLaterButtonBorderColour.trim().length > 0)
                    || (vehPayLaterButtonBorderStyle.trim().length > 0)) {
                    this._vehPayLaterButtonBorderFull = vehPayLaterButtonBorderColour + " " + vehPayLaterButtonBorderStyle;
                }

                if (vehRequestButtonTextColour.trim().length > 0) {
                    this._vehRequestButtonTextColour = vehRequestButtonTextColour;
                }
                if (vehRequestButtonBackColour.trim().length > 0) {
                    this._vehRequestButtonBackColour = vehRequestButtonBackColour;
                }
                if ((vehRequestButtonBorderColour.trim().length > 0)
                    || (vehRequestButtonBorderStyle.trim().length > 0)) {
                    this._vehRequestButtonBorderFull = vehRequestButtonBorderColour + " " + vehRequestButtonBorderStyle;
                }

                if (vehUnavailableButtonTextColour.trim().length > 0) {
                    this._vehUnavailableButtonTextColour = vehUnavailableButtonTextColour;
                }
                if (vehUnavailableButtonBackColour.trim().length > 0) {
                    this._vehUnavailableButtonBackColour = vehUnavailableButtonBackColour;
                }
                if ((vehUnavailableButtonBorderColour.trim().length > 0)
                    || (vehUnavailableButtonBorderStyle.trim().length > 0)) {
                    this._vehUnavailableButtonBorderFull = vehUnavailableButtonBorderColour + " " + vehUnavailableButtonBorderStyle;
                }

                if (excessToCaption.trim().length > 0) {
                    this._excessToCaption = excessToCaption;
                }
                if (passengerCaption.trim().length > 0) {
                    this._passengerCaption = passengerCaption;
                }
                if (suitcaseCaption.trim().length > 0) {
                    this._suitcaseCaption = suitcaseCaption;
                }
                if (airconCaption.trim().length > 0) {
                    this._airconCaption = airconCaption;
                }
                if (unavailableCaption.trim().length > 0) {
                    this._unavailableCaption = unavailableCaption;
                }
                break;

            case enumAsyncLoad.ClientConfigs:
                let imgHeight: string = this._configDataService.getClientConfig(enumClientConfig.cconf_AvailVehImageHeight, "100");
                if ((imgHeight.length > 0)
                    && (!isNaN(Number(imgHeight)))) {

                    this._imageHeight = Number(imgHeight);
                }

                let smallImgWidth: string = this._configDataService.getClientConfig(enumClientConfig.cconf_AvailVehSmallImageWidth, "300");
                if ((smallImgWidth.length > 0)
                    && (!isNaN(Number(smallImgWidth)))) {

                    this._smallImageWidth = Number(smallImgWidth);
                }

                this._canPayNow = (this._configDataService.getClientConfig(enumClientConfig.cconf_OfferPayNow) == "1");

                var baseVehImgURL = "/img/vehicleImages/";
                let configVehImgURL: string = this._configDataService.getClientConfig(enumClientConfig.cconf_VehicleImageFolder, baseVehImgURL);
                if (configVehImgURL.trim().length > 0) {
                    this._baseVehImgURL = configVehImgURL;
                }

                var baseIconImgURL = "/img/icons/";
                let configIconImgURL: string = this._configDataService.getClientConfig(enumClientConfig.cconf_IconImageFolder, baseIconImgURL);
                if (configIconImgURL.trim().length > 0) {
                    this._baseIconImgURL = configIconImgURL;
                }

                this._showAuxVehicleInfo = (this._configDataService.getClientConfig(enumClientConfig.cconf_ShowAuxVehicleInfo) == "1");

                break;
        }

        this._fullyLoaded = fullyLoaded;

        if (fullyLoaded) {
            //get the current BusinessEvent's data
            this.loadBusinessEvent();
        }
    }

    private loadBusinessEvent() {
        let errors: OTA_Error[] = new Array<OTA_Error>();

        if (this._otaResponse == null) {
            let otaError: OTA_Error = new OTA_Error();
            otaError.shortText = "No response received";
            errors.push(otaError);
        }
        else {
            if ((this._otaResponse.callStatus != null) 
                && (this._otaResponse.callStatus.code != enumCallStatus.csStatus_OK)) 
            {
                let otaError: OTA_Error = new OTA_Error();
                otaError.shortText = "Error - " + this._otaResponse.callStatus.code.toString();
                //TODO specific messages per CallStatus code?
                errors.push(otaError);
            }
            else {
                if ((this._otaResponse.otA_VehAvailRateRS.errors != null) 
                    && (this._otaResponse.otA_VehAvailRateRS.errors.length > 0)) {
                    errors = this._otaResponse.otA_VehAvailRateRS.errors;
                }
                else {
                    if ((this._otaResponse.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails == null)
                        || (this._otaResponse.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails.length == 0)
                        || (this._otaResponse.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails[0].vehAvails == null)
                        || (this._otaResponse.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails[0].vehAvails.length == 0)) {

                        let otaError: OTA_Error = new OTA_Error();
                        otaError.shortText = "There are no results";
                        //TODO specific messages per CallStatus code?
                        errors.push(otaError);
                    }
                    else {
                        //filter out the currently selected SIPP code (if there is one, and we are NOT offering Pay Now); and then order by cheapest first; then by availability
                        let selectedSIPP: string = "";
                        if ((this._be.otaVehAvail != null) && (!this._canPayNow))
                            selectedSIPP = this._be.otaVehAvail.vehAvailCore.vehicle.code;

                        this._otaVehAvails = this._otaResponse.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails[0].vehAvails.filter(va => va.vehAvailCore.vehicle.code != selectedSIPP).sort((n1, n2) => {
                            if (n1.vehAvailCore.totalCharge.estimatedTotalAmount == 0) {
                                if (n2.vehAvailCore.totalCharge.estimatedTotalAmount == 0) {
                                    return 0;
                                }
                                else {
                                    return 1;
                                }
                            }

                            if (n2.vehAvailCore.totalCharge.estimatedTotalAmount == 0) {
                                if (n1.vehAvailCore.totalCharge.estimatedTotalAmount == 0) {
                                    return 0;
                                }
                                else {
                                    return -1;
                                }
                            }

                            if (n1.vehAvailCore.totalCharge.estimatedTotalAmount > n2.vehAvailCore.totalCharge.estimatedTotalAmount) {
                                return 1;
                            }

                            if (n1.vehAvailCore.totalCharge.estimatedTotalAmount < n2.vehAvailCore.totalCharge.estimatedTotalAmount) {
                                return -1;
                            }

                            //estimated cost is the same so use availability
                            switch (n1.vehAvailCore.status) {
                                case "Available":
                                    switch (n2.vehAvailCore.status) {
                                        case "Available":
                                            return 0;
                                        case "OnRequest":
                                            return -1;
                                        case "Unavailable":
                                            return -1;
                                    }
                                    break;

                                case "OnRequest":
                                    switch (n2.vehAvailCore.status) {
                                        case "Available":
                                            return 1;
                                        case "OnRequest":
                                            return 0;
                                        case "Unavailable":
                                            return -1;
                                    }
                                    break;

                                case "Unavailable":
                                    switch (n2.vehAvailCore.status) {
                                        case "Available":
                                            return 1;
                                        case "OnRequest":
                                            return 1;
                                        case "Unavailable":
                                            return 0;
                                    }
                                    break;
                            }

                            return 0;
                        });
                    }
                }
            }
        }

        if (errors.length > 0) {
            //errors, so inform the user, and take them back to the previous page
            for (var otaErr in errors) {
                this._loadingErrorMsgs.push(errors[otaErr].shortText);
            }
        }

        //show the current booking info, even if there are OTA response errors
        this._locationOut = this._be.locationOut.description;
        this._locationIn = this._be.locationIn.description;

        var dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        var timeOptions = { hour: 'numeric', minute: '2-digit' };
        this._dateTimeOut = ((this._be.dateTimeOut == null) ? "<unknown>" :
            this._be.dateTimeOut.toLocaleDateString(navigator.language, dateOptions)
            + " at " + this._be.dateTimeOut.toLocaleTimeString(navigator.language, timeOptions));
        this._dateTimeIn = ((this._be.dateTimeIn == null) ? "<unknown>" :
            this._be.dateTimeIn.toLocaleDateString(navigator.language, dateOptions)
            + " at " + this._be.dateTimeIn.toLocaleTimeString(navigator.language, timeOptions));

        this._deliveryAddress = (this._be.deliveryAddress == null ? "" : "to " + this._be.deliveryAddress.replace(/\n/g, ", "));
        this._collectionAddress = (this._be.collectionAddress == null ? "" : "from " + this._be.collectionAddress.replace(/\n/g, ", "));

        this._reference = (this._be.reference == null ? "" : this._be.reference);
        if (this._reference.length > 0)
            this._reference = " - " + this._reference;

        this._payNow = this._be.payNow;

        //ensure we're positioned at the top of the page
        window.scroll(0, 0);

        this.validateForm();
    }

    private createOTARequest(): OTA_Request {
        //construct the OTA Request object for the current business event
        let otaReq: OTA_Request = new OTA_Request(enumRequestType.reqType_VehAvailRate);

        try {
            //remove any timezone offest from the DateTimes we've created
            const millisecondsPerMinute = 60000;
            if (this._be.dateTimeOut != null) {
                var offsetDateTimeOut: Date = new Date(this._be.dateTimeOut.valueOf() - (this._be.dateTimeOut.getTimezoneOffset() * millisecondsPerMinute));
                otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehRentalCore.pickUpDateTime = offsetDateTimeOut;
            }
            if (this._be.dateTimeIn != null) {
                var offsetDateTimeIn: Date = new Date(this._be.dateTimeIn.valueOf() - (this._be.dateTimeIn.getTimezoneOffset() * millisecondsPerMinute));
                otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehRentalCore.returnDateTime = offsetDateTimeIn;
            }

            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehRentalCore.pickUpLocation.locationCode = this._be.locationOut.code;
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehRentalCore.returnLocation.locationCode = this._be.locationIn.code;

            var otaVehPref: OTA_VehPref = new OTA_VehPref();
            otaVehPref.code = "*";
            otaVehPref.codeContext = "SIPP";
            otaVehPref.vehType.vehicleCategory = OTA_VehType.categoryFromEraVehicleType(this._be.vehicleType.vehicleTypeId);
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehPrefs.push(otaVehPref);
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.driverType.code = 1;
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.driverType.age = this._be.ageRange.ageApplied;
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.driverType.quantity = 1;

            if ((this._be.promoCode != null) 
                && (this._be.promoCode.trim().length > 0)) {


                switch (this._be.promotionType.promotionTypeId) {
                    case enumPromotionType.ptCustomerId:
                        //Customer ID
                        otaReq.otA_VehAvailRateRQ.vehAvailRQCore.rateQualifier.corpDiscountNmbr = this._be.promoCode.trim();
                        break;

                    case enumPromotionType.ptPromoCode:
                        //PromotionCode 
                        otaReq.otA_VehAvailRateRQ.vehAvailRQCore.rateQualifier.promotionCode = this._be.promoCode.trim();
                        break;
                }
            }

            if (this._be.hasDelivery) {
                let delivery: OTA_OffLocService = new OTA_OffLocService();
                delivery.type = "VehDelivery";
                delivery.address.addressLines.push(this._be.deliveryAddress);
                otaReq.otA_VehAvailRateRQ.vehAvailRQInfo.offLocServices.push(delivery);
            }

            if (this._be.hasCollection) {
                let collection: OTA_OffLocService = new OTA_OffLocService();
                collection.type = "VehCollection";
                collection.address.addressLines.push(this._be.collectionAddress);
                otaReq.otA_VehAvailRateRQ.vehAvailRQInfo.offLocServices.push(collection);
            }
        }
        catch (e) {
            console.log(e);
        }

        return otaReq;
    }

    private save(selectedVehicle: OTA_VehAvail, skipCount: number = 0): boolean {
        if (this._hasError) {
            return false;
        }

        if ((selectedVehicle != null)
            && (selectedVehicle.vehAvailCore.vehicle.code != null)) {
            this._be.vehicleGroupReserved = selectedVehicle.vehAvailCore.vehicle.code;
            this._be.vehicleSelected = true;
            this._be.otaVehAvail = selectedVehicle;
            this._be.payNow = this._payNow;
        }

        this._be.rentalChanged = (this._be.rentalChanged || this._hasChanged);

        //this._nextStep = this._beDataService.setBusinessEventForStep(this._currentStep, this._be, skipCount);
        this._nextStep = this._beDataService.setBusinessEventForStep(this._currentStep, this._be, 0);
        return true;
    }

    private goToPrevious() {
        //navigate to the previous page
        this.navigateTo(this._previousStep);
    }

    private goToNext(selectedVehicle: OTA_VehAvail, changed: boolean, payNow: boolean = false) {
        let skipCount: number = 0;

        //the next step should be the one that offers the coice of Equipment and alternative Coverages
        //if there are non available, go straight past this step
        if ((selectedVehicle.vehAvailCore.pricedEquips.length == 0)
            || (selectedVehicle.vehAvailInfo.pricedCoverages.filter(x => !x.charge.includedInEstTotalInd).length == 0)) {
            skipCount = 1;
        }

        if (changed) {
            this._payNow = payNow;
        }

        this._hasChanged = changed;

        if (this.save(selectedVehicle, skipCount)) {
            //navigate to the next page
            this.navigateTo(this._nextStep);
        }
    }

    private navigateTo(step: string, skipCount: number = 0) {
        //navigate to the given page
        if (step.trim().length > 0)
            this._router.navigate(['/' + step]);
    }

    //
    //validation methods
    //
    private validateForm() {
        this._hasError = ((this._nextStep.length == 0)
            || (this._previousStep.length == 0));
    }

    //
    //helpers
    //
    private rateDistanceDescription(vehAvail: OTA_VehAvail): string {
        var description = "";
        if ((vehAvail != null)
            && (vehAvail.vehAvailCore != null)
            && (vehAvail.vehAvailCore.rentalRate != null)
            && (vehAvail.vehAvailCore.rentalRate.rateDistance != null)) {

            if (vehAvail.vehAvailCore.rentalRate.rateDistance.unlimited)
                description = "Unlimited mileage";
            else
                //description = "Limited mileage"; //TODO - use mileage rate eg. 200km/day
                description = vehAvail.vehAvailCore.rentalRate.rateDistance.quantity.toString() + " "
                    + vehAvail.vehAvailCore.rentalRate.rateDistance.distUnitName
                    + (vehAvail.vehAvailCore.rentalRate.rateDistance.vehiclePeriodUnitName == "RentalPeriod" ? "" : " per " + vehAvail.vehAvailCore.rentalRate.rateDistance.vehiclePeriodUnitName);
        }

        return description;
    }

    private totalCostDescription(vehAvail: OTA_VehAvail, payNow: boolean = false): string {
        var totalCostDescription = "";
        var payNowDiscount = 0;

        if ((vehAvail != null)
            && (vehAvail.vehAvailCore != null)
            && (vehAvail.vehAvailCore.totalCharge != null)) {

            if (payNow) {
                if ((vehAvail.vehAvailCore.rentalRate != null)
                    && (vehAvail.vehAvailCore.rentalRate.vehCharges != null)) {

                    vehAvail.vehAvailCore.rentalRate.vehCharges.forEach(function (chrg) {
                        chrg.calculations.forEach(function (calc) {
                            payNowDiscount = payNowDiscount + ((chrg.amount + chrg.taxAmounts[0].total) * 0.1);
                        });
                    });
                }
            }

            let cost: CurrencyAmount = new CurrencyAmount();
            cost.amount = vehAvail.vehAvailCore.totalCharge.estimatedTotalAmount - payNowDiscount;
            cost.currencyCode = vehAvail.vehAvailCore.totalCharge.currencyCode;
            totalCostDescription = this._configDataService.formatCurrencyAmount(cost);
        }

        return totalCostDescription;
    }

    private baseRatesDescription(vehAvail: OTA_VehAvail, payNow: boolean = false): string {
        var baseRatesDescription = "";

        var rates = new Array<CurrencyAmount>();

        if ((vehAvail != null)
            && (vehAvail.vehAvailCore != null)
            && (vehAvail.vehAvailCore.rentalRate != null)
            && (vehAvail.vehAvailCore.rentalRate.vehCharges != null)) {

            //total up the rates (per currency and unitName)
            vehAvail.vehAvailCore.rentalRate.vehCharges.forEach(function (chrg) {
                chrg.calculations.forEach(function (calc) {

                    if (calc.quantity > 0)
                    {
                        var currAmnt = rates.find(x => ((x.currencyCode == chrg.currencyCode)
                            && (x.unitName == calc.unitName)));

                        if (currAmnt == null) {
                            currAmnt = new CurrencyAmount()
                            currAmnt.currencyCode = chrg.currencyCode;
                            currAmnt.unitName = calc.unitName;
                            currAmnt.amount = 0;
                            rates.push(currAmnt);
                        }

                        currAmnt.amount = currAmnt.amount
                            + (payNow ? (calc.total / calc.quantity) * 0.9 : (calc.total / calc.quantity));
                    }
                });
            });

            for (var amnt in rates) {
                baseRatesDescription = baseRatesDescription
                    + (baseRatesDescription.length > 0 ? " + " : "")
                    + this._configDataService.formatCurrencyAmount(rates[amnt], true);
            }
        }

        return baseRatesDescription;
    }

    private formatPricedCoverExcess(cvr: OTA_PricedCoverage): string {
        let currAmnt: CurrencyAmount = new CurrencyAmount();
        currAmnt.currencyCode = cvr.currencyCode;
        currAmnt.amount = cvr.excessAmount;

        return this._configDataService.formatCurrencyAmount(currAmnt);
    }

    private pluralise(nmbr: number): string {
        return (nmbr == 1 ? "" : "s");
    }

    private vehicleImageURL(vehAvail: OTA_VehAvail): string {
        var imageURL = ""

        if ((vehAvail != null)
            && (vehAvail.vehAvailCore != null)
            && (vehAvail.vehAvailCore.vehicle != null)) {

            //imageURL = vehAvail.vehAvailCore.vehicle.vehicleImageRef;
            imageURL = vehAvail.vehAvailCore.vehicle.code + ".png";

            if (imageURL.length > 0) 
                imageURL = this._baseVehImgURL + imageURL;
        }

        return imageURL;
    }

    private onImgError(event) {
        event.target.src = this._baseVehImgURL + "Coming_Soon.png";
    }

    private iconImageURL(imgName: string): string {
        return this._baseIconImgURL + imgName + ".png";
    }
}
